import * as React from 'react';
import { AppContext } from '../AppContext';

interface IButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color?: ButtonColors;
  mini?: boolean;
}

type ButtonColors = 'normal' | 'red' | 'white';

export const Button: React.FC<IButtonProps> = function ({ color, mini, ...buttonHTMLProps }) {
  color = color ?? 'normal';
  let colorClassName: string;
  switch (color) {
    case 'red':
      colorClassName = ' App-button_color_red';
      break;
    case 'white':
      colorClassName = ' App-button_color_gray';
      break;
    case 'normal':
    default:
      colorClassName = ' App-button_color_green';
      break;
  }

  let miniClassName = '';
  if (mini) {
    miniClassName = ' App-button_mini';
  }

  let className = 'App-button';
  if (buttonHTMLProps.className) {
    className += ` ${buttonHTMLProps.className}`;
  }

  return (
    <button {...buttonHTMLProps} className={className + colorClassName + miniClassName}>
      {buttonHTMLProps.children}
    </button>
  );
};

interface UpdateButtonProps extends IButtonProps {
  create: boolean;
}

export const UpdateButton: React.FC<UpdateButtonProps> = function ({ create, ...buttonHTMLProps }) {
  if (create) {
    return <Button {...buttonHTMLProps}>登録</Button>;
  }
  return <Button {...buttonHTMLProps}>保存</Button>;
};

interface IAuthButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color?: ButtonColors;
  mini?: boolean;
  authLv: number;
}

export const AuthButton: React.FC<IAuthButtonProps> = function ({ authLv, ...props }) {
  const appContext = React.useContext(AppContext);
  const me = appContext.state.me;

  if (!me) {
    return null;
  }

  if (me.authority.level < authLv) {
    return null;
  }

  return <Button {...props}>{props.children}</Button>;
};
